var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconaArteCulturaFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.37,3.17H2.63A2.63321,2.63321,0,0,0,0,5.8v8.41a2.63321,2.63321,0,0,0,2.63,2.63H17.37A2.63321,2.63321,0,0,0,20,14.21V5.8A2.63321,2.63321,0,0,0,17.37,3.17ZM8.91,5.27A4.79309,4.79309,0,0,1,10,5.15a4.94774,4.94774,0,0,1,1.1.12,4.86744,4.86744,0,0,1,.04,9.47,5.06317,5.06317,0,0,1-2.28,0,4.866,4.866,0,0,1,.05-9.47ZM16.32,7.89a1.05,1.05,0,1,1,1.05-1.05A1.05847,1.05847,0,0,1,16.32,7.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.34,2.12H2.63a1.82828,1.82828,0,0,0-.33.02L3.36,0H9.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.89583,1.05263V2.15788a2.87828,2.87828,0,0,0-.52631-.04208H16.8432V2.10526H13.6853V2.1158H12.63267V1.05263Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.80112,19.67369A.525.525,0,0,1,16.31688,20H3.6853a.525.525,0,0,1-.48423-.32631.49935.49935,0,0,1,.11584-.56847l1.05263-1.05263a.521.521,0,1,1,.73679.73686l-.14732.15792H15.04318l-.14732-.15792a.521.521,0,0,1,.73679-.73686l1.05263,1.05263A.49935.49935,0,0,1,16.80112,19.67369Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaArteCulturaFill);
export default __webpack_public_path__ + "static/media/iconaArteCulturaFill.eb2bb11cfbbf758bc2e11445daaaffa4.svg";
export { ForwardRef as ReactComponent };